import { useDispatch, useSelector } from 'react-redux';
import {
  getInsightsPreferences,
  getOverviewPreferences,
  getVrrPreferences,
  updateInsightsSettings,
  updateOverviewSettings,
  updateVrrSettings
} from '../../redux/settings/settingAction';

const useVrrSettings = () => {
  const dispatch: any = useDispatch();
  const resource_id = useSelector(getVrrPreferences)?.resource_id;
  return (value: any, notification: boolean) => {
    dispatch(
      updateVrrSettings({ resource_id: resource_id ?? 0, value, notification })
    );
  };
};

const useOverviewSettings = () => {
  const dispatch: any = useDispatch();
  const overview = useSelector(getOverviewPreferences);
  return (
    node: 'global_metrics' | 'detailed_metrics' | 'chart_metrics',
    value: any,
    notification: boolean
  ) => {
    const resource_id = overview?.[node]?.resource_id;
    dispatch(
      updateOverviewSettings({
        resource_id: resource_id ?? 0,
        value,
        notification
      })
    );
  };
};

const useInsightsSettings = () => {
  const dispatch: any = useDispatch();
  const insights = useSelector(getInsightsPreferences);
  return (node: 'filters' | 'cards' | 'current_tab', value: any) => {
    const resource_id = insights?.resource_id;
    dispatch(
      updateInsightsSettings({
        resource_id: resource_id ?? 0,
        value: {
          [node]: value
        }
      })
    );
  };
};

const useSettings = (): any => {
  const vrr = useVrrSettings();
  const overview = useOverviewSettings();
  const insights = useInsightsSettings();
  return {
    vrr,
    overview,
    insights
  };
};

export default useSettings;
